var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconLinkedinColored(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.14612C0 0.5135 0.529625 0 1.1825 0H14.8175C15.4706 0 16 0.5135 16 1.14612V14.8541C16 15.4869 15.4706 16 14.8175 16H1.1825C0.529688 16 0 15.4869 0 14.8542V1.14594V1.14612Z",
    fill: "#006699"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.86216 13.39V6.18673H2.46791V13.39H4.86241H4.86216ZM3.66553 5.20342C4.50028 5.20342 5.01997 4.65029 5.01997 3.95904C5.00434 3.25204 4.50028 2.71436 3.68141 2.71436C2.86197 2.71436 2.32678 3.25204 2.32678 3.95898C2.32678 4.65023 2.84628 5.20336 3.64984 5.20336H3.66534L3.66553 5.20342ZM6.18741 13.39H8.58147V9.36779C8.58147 9.15279 8.5971 8.93723 8.66035 8.78367C8.83334 8.35336 9.22728 7.90792 9.88885 7.90792C10.755 7.90792 11.1017 8.56842 11.1017 9.53685V13.39H13.4957V9.25986C13.4957 7.04742 12.3147 6.01785 10.7395 6.01785C9.44803 6.01785 8.88084 6.73967 8.56572 7.23129H8.58166V6.18698H6.18753C6.21878 6.86273 6.18734 13.3902 6.18734 13.3902L6.18741 13.39Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLinkedinColored);
export default __webpack_public_path__ + "static/media/icon-linkedin-colored.e2b1549ef18d5d368ce60b0322610e31.svg";
export { ForwardRef as ReactComponent };